import { useState, useEffect } from 'react'
import { getPointsByGroup, getPointsByPerspective, getPoints } from '../api/points-interest'
import { Shape } from '../components/ShapesMap/ShapesMap'

export const usePois = (perspectives = [], restrictedPerspectives = [], viewSettings): any[] => {
    const [pointsInterest, setPointInterest] = useState<any>({ data: [] })
    const [filteredIds, setFilteredIds] = useState([])
    const [filtersPoiActive, setFiltersPoiActive] = useState(false);

    useEffect(() => {
        if (viewSettings.allPois) {
            getPois(perspectives, restrictedPerspectives)
        }
    }, [viewSettings])

    const toDataShape = (points: any[]): Shape[] => {
        const shapes: Shape[] = []
        points.forEach(({ type, points, radius, name, info, id, poiType, groupId }) => {
            const shape: Shape = {
                id,
                type,
                locations: [],
                radius,
                name,
                poiType,
                groupId,
                description: info
            }

            points.forEach(point => {
                shape.locations.push({ lat: +point[0], lng: +point[1] })
            })

            shapes.push(shape)
        })

        return shapes
    }

    const getFIlteredIds = (points) => {
        return points.map(point => point.id)
    }

    const getPois = async (perspectives = [], restrictedPerspectives = []): Promise<void> => {

        perspectives = perspectives.filter(id => {
            return restrictedPerspectives.find(perspective => perspective.value === id) === undefined
        })

        try {
            const response2 = await getPointsByGroup([])
            setPointInterest(toDataShape(response2.data))
            if (viewSettings.groupsSelected.length > 0) {
                const response = await getPointsByGroup(viewSettings.groupsSelected.map(obj => obj.value))
                setFilteredIds(getFIlteredIds(response.data))
            }
        } catch (error) { }
    }

    return [pointsInterest, filteredIds, filtersPoiActive]
}
